module.exports = __webpack_public_path__ + "static/img/102190.014227cf.png";